module.exports = __webpack_public_path__ + "img/maker_kenlock.e350ba9b.jpg";